export enum EventNames {
  SetChatVisibility = 'UASetChatVisibility',
  GoToPage = 'UAGoToPage',
}

export type EventDetails = {
  [EventNames.SetChatVisibility]: {
    open: boolean;
  };
  [EventNames.GoToPage]: {
    pageId?: string;
    pageInputs?: Record<string, unknown>;
  };
};

type SetChatVisibilityEvent = {
  event: EventNames.SetChatVisibility;
  props: EventDetails[EventNames.SetChatVisibility];
};

type GoToPageEvent = {
  event: EventNames.GoToPage;
  props: EventDetails[EventNames.GoToPage];
};

export type DMCustomEvent = SetChatVisibilityEvent | GoToPageEvent;

export type UAWebApplicationRef =
  | {
      goToPage: (args: EventDetails[EventNames.GoToPage]) => void;
    }
  | undefined;
